import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { ApplicationPrefix } from '@openx/constants/paths.ts';
import { dealFormField } from '@openx/types/deal.ts';
import { isPathInApp } from '@openx/utils/lib/isPathInApp.ts';
import { InfoIcon } from '@phosphor-icons/react/Info';
import { type JSX, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type GeneratedIdTypes, generatedDirectDealsIdTypes, generatedIdTypes } from './enums.ts';
import { StyledBox, StyledFixedSizeAutoComplete, StyledTooltip } from './styled/index.ts';

type IdGeneratedRadioProps = {
  disabled?: boolean;
};

export const IdGeneratedRadio = ({ disabled = false }: IdGeneratedRadioProps): JSX.Element => {
  const { t } = useTranslation();

  // im not a fan, but this is the only way to check for publisher without huge refactor
  const isPub = isPathInApp(window.location.pathname, ApplicationPrefix.Publisher);
  const options = Object.values({ ...generatedIdTypes, ...(isPub && generatedDirectDealsIdTypes) });

  const renderOptions = useMemo(
    () => ({
      dataTest: (option: GeneratedIdTypes) => `radio-generated-option-${option}`,
      getOptionValue: (option: GeneratedIdTypes) => option,
    }),
    []
  );

  return (
    <StyledBox data-test="id-generated-radio">
      <Typography noWrap>{t('Generated by OpenX with prefix:')}</Typography>
      <StyledFixedSizeAutoComplete
        name={dealFormField.GENERATED_DEAL_ID_PREFIX}
        data-test="radio-generated-prefix-autocomplete"
        textFieldProps={{
          margin: 'dense',
        }}
        disableClearable
        renderOptions={renderOptions}
        getOptionLabel={option => option}
        options={options}
        disabled={disabled}
      />
      <StyledTooltip
        title={t(
          'Default option will create OX-prefix using 3 first letters of the instance name. Selecting other options will override this and create the deal with chosen prefix. Remaining characters will be autogenerated by the system.'
        )}
        placement="right"
      >
        <IconButton size="small">
          <InfoIcon />
        </IconButton>
      </StyledTooltip>
    </StyledBox>
  );
};
